import React from "react";
import ContactGlobalIcon from "./ContactGlobalIcon";
import { HomeOutlined } from "@ant-design/icons";
export const ButtonCommon = ({
  title,
  onClick = () => {},
  // className = "",
  // disabled,
  // customStyle,
  // sticky,
  // bgYellow,
  // bgGray,
  // bgOutlineBlue,
  // bgDelete,
  // bgRed,
  // bgBlue,
  // bgCancel,
  // type = "button",
}) => {
  // let classNameBtn = "btn-common ";
  // if (sticky) classNameBtn += "btn-common-sticky ";
  // if (bgYellow) classNameBtn += "btn-yellow";
  // if (bgGray) classNameBtn += "btn-gray";
  // if (bgDelete) classNameBtn += "btn-delete";
  // if (bgRed) classNameBtn += "btn-red";
  // if (bgBlue) classNameBtn += "btn-blue";
  // if (bgCancel) classNameBtn += "btn-cancel";
  // if (bgOutlineBlue) classNameBtn += "btn-outline-blue";
  // classNameBtn += className;
  return (
    <button
      // type={type}
      // style={customStyle}
      // disabled={disabled}
      onClick={() => {
        onClick();
      }}
      className="btn-global-v1"
    >
      {title}
    </button>
  );
};
export const BreadcrumTitle = ({ title }) => {
  return <div className="breadcrum-global-v1">{title}</div>;
};
export const BreadcrumTitleMedium = ({ title }) => {
  return <div className="breadcrum-global-medium-v1">{title}</div>;
};
export const BreadcrumSmall = ({ title }) => {
  return (
    <div className="breadcrum-global-small">
      <HomeOutlined /> / <div className="_text">{title}</div>
    </div>
  );
};
export const renderTypeModal = (type) => {
  switch (type) {
    case 1:
      return <div>Màn hình android</div>;
    case 2:
      return <div>Nâng cấp ánh sáng</div>;
    case 3:
      return <div>Led nội thất</div>;
    case 4:
      return <div>Camera hành trình</div>;
    case 5:
      return <div>Cốp điện</div>;
    case 66:
      return <div>Âm thanh</div>;
    // Add more cases as needed
    default:
      return <div>--</div>;
  }
};
export const capitalizeFirstLetter = (string) => {
  if (!string) return ""; // Check for empty string or undefined
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const ModalContactConsultation = ({ title, onClose }) => {
  return (
    <div className="custom-modal-consultation">
      <div className="_left">
        <div className="pattern-bg" />
        <div className="logo-block">
          <img src="/logo279.png" alt="Logo" />
          <h2>
            Auto 279 <br />
            Chuyên Gia Chăm Sóc Xe
          </h2>
          <p>
            Chúng tôi vừa mới khai trương! Với đội ngũ chuyên gia tận tâm và
            trang thiết bị hiện đại, chúng tôi cam kết mang đến dịch vụ chăm sóc
            xe chất lượng cao nhất. Đặc biệt, khách hàng đầu tiên sẽ nhận được
            ưu đãi hấp dẫn!
          </p>
        </div>
        <div className="promo-block">
          <div className="promo-content">
            <div className="promo-item">
              <div className="promo-title">Mới</div>
              <div className="promo-desc">Khai Trương</div>
            </div>
            <div className="promo-divider" />
            <div className="promo-item">
              <div className="promo-title">-20%</div>
              <div className="promo-desc">Ưu Đãi</div>
            </div>
          </div>
        </div>
      </div>
      <div className="_right">
        <button className="close-btn" onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6 6L18 18"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="contact-header">
          <h3>Liên Hệ Tư Vấn</h3>
          <p>Chọn phương thức liên hệ phù hợp để được hỗ trợ nhanh nhất</p>
        </div>
        <div className="contact-methods">
          <ContactGlobalIcon consult={true} />
        </div>
        <div className="contact-note">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 6V12L16 14"
              stroke="#888"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Chúng tôi sẽ phản hồi trong vòng 30 phút!</span>
        </div>
      </div>
    </div>
  );
};
